import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Button, Layout } from '@loadsmart/miranda-react'

import { EmptyStateWrapper } from './EmptyState.styles'

export type ErrorShipmentsListStateProps = {
  onReloadShipments: () => void
}

export function ErrorShipmentsListState({ onReloadShipments }: ErrorShipmentsListStateProps) {
  function handleOnReloadShipments() {
    onReloadShipments()
  }

  return (
    <EmptyStateWrapper>
      <Layout.Stack gap="spacing-4" align="center">
        <EmptyState
          title="Oops! Sorry for that"
          description="We've failed to load the page content"
          variant="page"
        />
        <Layout.Group>
          <Button type="button" variant="secondary" onClick={handleOnReloadShipments}>
            Try again
          </Button>
        </Layout.Group>
      </Layout.Stack>
    </EmptyStateWrapper>
  )
}
